import { Route } from "react-router-dom";

import { authRoutes } from "./routes";

export const AuthRoutes = () => {
  return (
    <>
      {authRoutes.map(({ path, Component, exact = false }) => (
        <Route path={path} key={path} exact={exact}>
          <Component />
        </Route>
      ))}
    </>
  );
};
